/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ArticleStatusType {
  Inactive = 'Inactive',
  Draft = 'Draft',
  Published = 'Published'
}
